<template>
  <thead>
    <transition-group name="fade" tag="tr">
      <th v-if="shouldRenderSelection" key="--th-multi">
        <multi-select :selection="selection" :rows="data" />
      </th>
      <th v-for="(col, idx) in columns"
        :key="col.title || col.field || idx"
        :class="col.thClass" :style="col.thComp">
        <label style="text-transform: none;"><div v-if="shownCategories.includes(col.category)">
          {{ col.category }}:
        </div>
          {{ col.title }}
        </label>
        <component
          v-if="col.thComp"
          :is="forDynCompIs(col.thComp)"
          :column="col"
          :field="col.field"
          :title="col.title"
          :items="col.items"
          :filterType="col.filterType"
          v-bind="$props">
        </component>

        <i v-if="col.explain" class="fa fa-info-circle" style="cursor: help" :title="col.explain"></i>
        <head-sort v-if="col.sortable" :field="col.field" :query="query" />
      </th>
      <!-- Two empty table headers for Edit and Delete -->
      <th v-if="Pagination && !isTrashBin" :key="'1'"> <template>  </template> </th>
      <th v-if="Pagination && !isTrashBin" :key="'2'"> <template>  </template> </th>
    </transition-group>
  </thead>
</template>
<script>
import HeadSort from './HeadSort.vue'
import MultiSelect from './MultiSelect.vue'
import props from '../_mixins/props'
import shouldRenderSelection from '../_mixins/shouldRenderSelection'
import config from '@/config.json'

export default {
  name: 'TableHeader',
  components: { HeadSort, MultiSelect },
  mixins: [props, shouldRenderSelection],
  data () {
    return {
      shownCategories: config.tab_settings.patient.shownCategories
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Datatable/src/Table/TableHeader.vue